export default __webpack_public_path__ + "static/media/leader_notes.14e5af06.pdf";